import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import { PROMO } from "@/constants/testIds";

// Card colours follow the app palette: deep green, cream, amber.
const CARD_STYLES = [
  {
    bg: "#123A2C",
    value: "#F5A623",
    label: "rgba(255,255,255,0.72)",
    border: "#123A2C",
  },
  { bg: "#E4DED2", value: "#123A2C", label: "#6B7280", border: "#D8D1C2" },
  { bg: "#F5A623", value: "#412402", label: "#6B4A12", border: "#F5A623" },
];

const PromoBanner = () => {
  const { t } = useLang();
  const { user } = useAuth();
  const navigate = useNavigate();
  const cards = t("promo.cards");

  return (
    <section data-testid={PROMO.root} className="mt-10">
      <div className="relative overflow-hidden rounded-3xl bg-[#123A2C] text-white px-6 py-8 sm:px-10 sm:py-10">
        {/* Decorative rings */}
        <span
          aria-hidden
          className="pointer-events-none absolute -top-16 -right-16 w-56 h-56 rounded-full border border-[rgba(245,166,35,0.25)]"
        />
        <span
          aria-hidden
          className="pointer-events-none absolute -bottom-20 right-10 w-48 h-48 rounded-full border border-[rgba(245,166,35,0.18)]"
        />

        <div className="relative">
          <h2 className="mt-5 text-2xl sm:text-3xl font-extrabold leading-snug max-w-2xl">
            {t("promo.title")}
          </h2>
          <p className="mt-2 text-sm sm:text-base text-[rgba(255,255,255,0.78)] max-w-xl">
            {t("promo.subtitle")}
          </p>

          <button
            data-testid={PROMO.cta}
            onClick={() => navigate(user ? "/market" : "/signup")}
            className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-[#F5A623] text-[#412402] font-semibold text-sm hover:brightness-95 transition"
          >
            {t("promo.cta")} <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-3 sm:gap-5 mt-4">
        {cards.map((c, i) => {
          const s = CARD_STYLES[i % CARD_STYLES.length];
          return (
            <div
              key={i}
              data-testid={`${PROMO.card}-${i}`}
              className="rounded-2xl p-3 sm:p-6 text-center border"
              style={{ backgroundColor: s.bg, borderColor: s.border }}
            >
              <div
                className="text-base sm:text-3xl font-extrabold leading-tight break-words"
                style={{ color: s.value }}
              >
                {c.v}
              </div>
              <div
                className="mt-1 text-[11px] sm:text-sm"
                style={{ color: s.label }}
              >
                {c.l}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default PromoBanner;
